class Header {
    constructor() {

        let submenus = document.querySelectorAll(".menu-item-has-children > a");
        let backlinks = document.querySelectorAll(".backbtn");
        let menumobile = document.querySelectorAll(".menu-mobile");
        let closeIco = document.querySelector(".btn-close");
        let searchbtn = document.querySelector(".search-btn");
        let searchform = document.querySelector(".searchform-content");
        let backshadowClose = document.querySelector(".backshadow");
        let closesearchs = document.querySelectorAll(".close-search");
        let btnorcamento = document.querySelector("#solicitarOrcamento");
        let close = document.querySelectorAll(".close-box");

        if (window.matchMedia("(max-width:1024px)").matches) {
            for (let submenu of submenus) {
                submenu.addEventListener('click', function (event) {
                    event.preventDefault();
                    this.nextSibling.nextSibling.classList.add('is-active')
                });
            }
        } else {
            for (let submenu of submenus) {
                submenu.addEventListener('click', function () {
                    let sub = this.getElementsByClassName('sub-menu');
                    sub[0].classList.toggle('is-active');
                });
            }
        }

        for (let backlink of backlinks) {
            backlink.addEventListener('click', function (event) {
                event.preventDefault();
                this.closest(".sub-menu").classList.remove("is-active");
            });
        }

        if (closeIco) {
            closeIco.addEventListener('click', function (event) {
                event.preventDefault();
                menumobile[0].classList.toggle('is-active');
                this.classList.toggle('close');
            });
        }

        searchbtn.addEventListener('click', function (event) {
            event.preventDefault();
            searchform.classList.toggle("show");
        });

        backshadowClose.addEventListener('click', function (event) {
            event.preventDefault();
            searchform.classList.remove("show");
        });

        document.getElementById("input-search").addEventListener("keyup", function (event) {
            if (event.keyCode === 13) {
                let form = document.getElementById("searchform");
                form.submit();
                return false;
            }
        });

        for (let closesearch of closesearchs) {
            closesearch.addEventListener('click', function (event) {
                event.preventDefault();
                searchform.classList.toggle("show");
            });
        }

        if (btnorcamento) {
            btnorcamento.addEventListener('click', function (event) {
                event.preventDefault();
                document.querySelector(".modal-orcamento").classList.add('show');
                if (document.querySelector('.product-single h1')) {
                    document.querySelector(".message").value = document.querySelector('.product-single h1').innerHTML;
                }
            });
        }

        if (close) {
            for (let i = 0; i < close.length; ++i) {
                close[i].addEventListener('click', function (event) {
                    event.preventDefault();
                    console.log(event.target);
                    event.target.closest(".modal-default").classList.remove('show');
                });
            }
        }

        let closeBg = document.querySelectorAll(".modal-default .bg");
        if(closeBg){
            for (let i = 0; i < closeBg.length; ++i) {
                closeBg[i].addEventListener('click', function(event) {
                    event.preventDefault();
                    event.target.closest(".modal-default").classList.remove('show');              
                });
            }
        }

        document.querySelector('.form-newsletter').addEventListener('submit', function(event){
            event.preventDefault()
            document.querySelector('.sucesso').style.display = 'block'
            document.querySelector('.browser-default').value = ''
        });
    }

}

export default Header;